import React, { useEffect, useState } from 'react';

import './Integrations.scss';
import { Avatar, Button, Card, Col, Modal, Row, Spin } from 'antd';
import { ReactSVG } from 'react-svg';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllCarriers } from '../../../modules/carriers/stores/slice';
import { doCreateCarrier, doGetCarriers, doUpdateCarrier } from '../../../modules/carriers/stores/thunk';
import { VeloydCarrier } from './Integrations/VeloydCarrier';
import { PeddlerCarrier } from './Integrations/PeddlerCarrier';
import { ROLES } from '../../../constants';
import { selectAllUsers } from '../../../modules/users/store/slice';
import { doGetUsers } from '../../../modules/users/store/thunk';

const { Meta } = Card;

const Carriers = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState({ isOpen: false, title: '', content: null });
  const resetModal = () => {
    setModal({ isOpen: false, title: '', content: null });
    dispatch(doGetCarriers());
  };

  const isFetching = useSelector((state) => state.carriers.isFetching);
  const carriers = useSelector((state) => selectAllCarriers(state));
  const users = useSelector((state) => selectAllUsers(state));

  useEffect(() => {
    dispatch(doGetCarriers());
    dispatch(doGetUsers({ page: 1, take: 1000, roles: [ROLES.CARRIER_USER] }));
  }, []);

  const handleCarrierUpdate = (input) => {
    if (input.id) {
      dispatch(doUpdateCarrier({ ...input }));
    } else {
      dispatch(doCreateCarrier({ ...input }));
    }
  };

  const renderCarrierCard = (carrier) => {
    if (carrier.carrierService === 'VELOYD') {
      return (
        <Col span={8} key={carrier.id}>
          <Card style={{ height: '100%' }}>
            <Meta
              avatar={<Avatar src="/icons/veloyd.png" />}
              title={carrier?.name}
              description="Veloyd is a delivery software platform. Connect your account to sync your orders."
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Button
                size="small"
                type="primary"
                onClick={() =>
                  setModal({
                    isOpen: true,
                    title: 'Veloyd Integration',
                    content: (
                      <VeloydCarrier
                        isFetching={isFetching}
                        done={resetModal}
                        carrier={carrier}
                        handleUpdate={handleCarrierUpdate}
                        users={users}
                      />
                    ),
                  })
                }
              >
                Update integration
              </Button>
            </div>
          </Card>
        </Col>
      );
    }
    if (carrier.carrierService === 'PEDDLER') {
      return (
        <Col span={8} key={carrier.id}>
          <Card style={{ height: '100%' }}>
            <Meta
              avatar={<Avatar src="/icons/peddler.png" />}
              title={carrier?.name}
              description="Peddler is a sustainable last mile carrier. Connect your account to sync your orders."
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Button
                size="small"
                type="primary"
                onClick={() =>
                  setModal({
                    isOpen: true,
                    title: 'Veloyd Integration',
                    content: (
                      <PeddlerCarrier
                        isFetching={isFetching}
                        done={resetModal}
                        carrier={carrier}
                        handleUpdate={handleCarrierUpdate}
                        users={users}
                      />
                    ),
                  })
                }
              >
                Update integration
              </Button>
            </div>
          </Card>
        </Col>
      );
    }
  };

  return (
    <div className="info">
      <div className="info-content">
        <h3>Carriers</h3>
        <h5>Find and enable carriers and connect them to your delivery areas to start shipping orders with them</h5>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <Button
          className="CreateButton ButtonWhite"
          size="small"
          onClick={() => window.open('mailto:maurice.stam@sparqle.com?subject=Carrier Request')}
        >
          Request Carrier
          <ReactSVG className="icon" src="/icons/plus.svg" />
        </Button>
      </div>
      <Spin spinning={isFetching}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Card style={{ height: '100%' }}>
              <Meta
                avatar={<Avatar src="/icons/urbeez.png" />}
                title="Urbeez"
                description="Urbeez is a sustainable last-mile carrier based in Brussels."
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Button size="small" type="link">
                  Contact Us
                </Button>
              </div>
            </Card>
          </Col>
          {carriers.map(renderCarrierCard)}
          <Col span={8}>
            <Card style={{ height: '100%' }}>
              <Meta
                avatar={<Avatar src="/icons/veloyd.png" />}
                title="Veloyd"
                description="Veloyd is a delivery software platform. Connect your account to sync your orders."
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Button
                  size="small"
                  type="primary"
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: 'Veloyd Integration',
                      content: (
                        <VeloydCarrier
                          isFetching={isFetching}
                          done={resetModal}
                          carrier={undefined}
                          handleUpdate={handleCarrierUpdate}
                        />
                      ),
                    })
                  }
                >
                  Add Integration
                </Button>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card style={{ height: '100%' }}>
              <Meta
                avatar={<Avatar src="/icons/peddler.png" alt="peddler logo" />}
                title="Peddler"
                description="Peddler is a sustainable last mile carrier. Connect your account to sync your orders."
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Button
                  size="small"
                  type="primary"
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: 'Peddler Integration',
                      content: (
                        <PeddlerCarrier
                          isFetching={isFetching}
                          done={resetModal}
                          carrier={undefined}
                          handleUpdate={handleCarrierUpdate}
                          users={users}
                        />
                      ),
                    })
                  }
                >
                  Add Integration
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
      <Modal
        width={552}
        closeIcon={false}
        title={modal.title}
        open={modal.isOpen}
        forceRender
        //onCancel={resetModal}
      >
        {modal.content}
      </Modal>
    </div>
  );
};

export default Carriers;
